import React from "react";
import { useAtomValue } from "jotai";
import { enhancedTasksAtom } from "../store/atoms/derivedAtoms.js";
import { useTasks, useMenu } from "../hooks/index.js";
import Bubble from "./Bubble";
import BubbleMenu from "./BubbleMenu";

const TaskBubbleContainer = () => {
  const enhancedTasks = useAtomValue(enhancedTasksAtom);
  const {
    categoryImages,
    hoveredTask,
    setHoveredTask,
    isDraggingBubble,
    setIsDraggingBubble,
  } = useTasks();
  const { showContextMenu } = useMenu();

  if (enhancedTasks.length === 0) {
    return (
      <div className="no-tasks-message">
        <h4>No tasks. Add a new task above!</h4>
      </div>
    );
  }

  return (
    <>
      {enhancedTasks.map((task) => (
        <Bubble
          key={task.task_id}
          task={task}
          categoryImages={categoryImages}
          hoveredTask={hoveredTask}
          setHoveredTask={setHoveredTask}
          isDraggingBubble={isDraggingBubble}
          setIsDraggingBubble={setIsDraggingBubble}
        />
      ))}

      {showContextMenu && <BubbleMenu />}
    </>
  );
};

export default TaskBubbleContainer;
